import { FC } from "react";
import { Button } from "@/components";
import { useNavigationError } from "@/hooks/useNavigationError";
import { ErrorResponse } from "@/types/errorResponse";
import { axiosAccountInstance } from "@/utils/axios";
import { formatRequestDateTime } from "@/utils/formatter";
import axios, { AxiosError } from "axios";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  startAt: Date;
  endAt: Date | null;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  setOpenSnackbar: Dispatch<SetStateAction<boolean>>;
};

export const SendSummaryPDFMailButton: FC<Props> = ({
  startAt,
  endAt,
  setIsLoading,
  setIsModalOpen,
  setOpenSnackbar,
}) => {
  const { t } = useTranslation();
  const { navigateError } = useNavigationError();

  const handleErrors = (error: AxiosError<ErrorResponse>) => {
    if (axios.isAxiosError(error)) {
      navigateError({
        error: error,
        endpoint: "/api/point/transfer/summary",
        appName: "POINT_TRANSFER_SUMMARY",
        path: "points",
      });
    }
  };

  const handleSend = async () => {
    try {
      setIsLoading(true);
      await axiosAccountInstance.post(`/api/point/transfer/summary/mail`, {
        start_at: formatRequestDateTime(startAt),
        ...(endAt && { end_at: formatRequestDateTime(endAt) }),
      });
      setIsModalOpen(true);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorCode = error.response?.data.error_code;
        if (["E400-12"].includes(errorCode)) {
          setOpenSnackbar(true);
        } else {
          handleErrors(error);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      sx={{
        order: { xs: 1, sm: 0 },
        width: "100%",
        borderRadius: "1000px",
        height: "56px",
      }}
      onClick={handleSend}
    >
      {t("SEND_PDF_EMAIL")}
    </Button>
  );
};
